<template>
  <div>
    <v-row dense no-gutters cols="12">      
      <v-col cols="5">
        <v-row dense>
          <v-col cols="12">
            <re_radioset :value="wizardData.purchase_relative" field="purchase_relative" @updateData="updateData"/>
          </v-col>
        </v-row>                
        <div v-if="wizardData.purchase_relative===true">
          <hsnp_wizard_step_02_purchase_relative :wizardData="wizardData" @updateData="updateData" class="ml-3"/>
        </div>
        <div v-else>
          <hsnp_wizard_step_02_purchase_exact :wizardData="wizardData" @updateData="updateData" class="ml-3"/>
        </div>
      </v-col>
      <v-col cols="6" class="mt-3">
        <weekdays :days="wizardData.purchase_days" field="purchase_days" color="primary" @updateData="updateData" class="ml-3"/>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4">
        <div class="mb-1 sub-title">Minimum purchase price</div>
        <v-divider></v-divider>
        <v-radio-group dense v-model="wizardData.purchase_minpurchase_auto_update" v-on:change="updateMinPurchaseAuto" class="mt-1">
          <v-radio key='0' label="Automatically update minimum purchase prices using the change parameters" :value=0></v-radio>
          <v-radio key='1' label="Manually set minimum price calculation parameters" :value=1></v-radio>
          <v-radio key='2' label="Do not update minimum purchase price" :value=2></v-radio>
        </v-radio-group>
      </v-col>
      <v-col cols="4">
        <div class="mb-1 sub-title">Sales price</div>
        <v-divider></v-divider>
        <v-radio-group dense v-model="wizardData.purchase_sales_auto_update" v-on:change="updatePurchaseSalesAuto" class="mt-1">
          <v-radio key='1' label="Automatically update sales prices using existing margin" :value=1></v-radio>
          <!-- <v-radio key='0' label="Automatically update sales prices using the change parameters" :value=0></v-radio> -->
          <v-radio key='2' label="Do not update sales price" :value=2></v-radio>
        </v-radio-group>
      </v-col>
      <v-col cols="4">
        <div class="mb-1 sub-title">Week price</div>
        <v-divider></v-divider>
        <v-radio-group dense v-model="wizardData.purchase_weekprice_auto_update" v-on:change="updatePurchaseWeekpriceAuto" class="mt-1">
          <v-radio key='0' label="Automatically update week prices using the change parameters" :value=0></v-radio>
          <v-radio key='1' label="Do not update week prices" :value=1></v-radio>
        </v-radio-group>
      </v-col>      
    </v-row>       

    <div v-if="wizardData.purchase_minpurchase_auto_update===1">
      <hsnp_wizard_step_02_minpurchase :wizardData="wizardData" @updateData="updateData"/>
    </div>

  </div>      
</template>

<script>

  import weekdays from '@/components/huis/hspt/ui/weekdays.vue';
  import re_radioset from '@/components/huis/hspt/ui/re_radioset.vue';
  import hsnp_wizard_step_02_minpurchase from '@/components/huis/hspt/hsnp/hsnp_wizard_step_02_minpurchase.vue';
  import hsnp_wizard_step_02_purchase_relative from '@/components/huis/hspt/hsnp/hsnp_wizard_step_02_purchase_relative.vue';
  import hsnp_wizard_step_02_purchase_exact from '@/components/huis/hspt/hsnp/hsnp_wizard_step_02_purchase_exact.vue';

  export default {
    props: {
      wizardData: Object
    },        
    components: {
      weekdays,
      re_radioset,
      hsnp_wizard_step_02_minpurchase,
      hsnp_wizard_step_02_purchase_relative,
      hsnp_wizard_step_02_purchase_exact,
    },
    methods:{
      updateMinPurchaseAuto(data){
        this.updateData({"field": "purchase_minpurchase_auto_update", "value": data});
      },
      updatePurchaseSalesAuto(data){
        this.updateData({"field": "purchase_sales_auto_update", "value": data});
      },
      updatePurchaseWeekpriceAuto(data){
        this.updateData({"field": "purchase_weekprice_auto_update", "value": data});
      },
      updateData(data){
        this.$emit('updateData', data);      
      }      
    }
  }
</script>

<style scoped>
  .sub-title{
    font-weight: bolder;
  }
</style>